export const fullUrl = (urlSlug: string) => `${window.location.origin}/${urlSlug}`;
